import * as React from "react";

import {I18NString, Component} from "../../Utils";

export interface IDescriptionProps {
    text: I18NString;
}

interface IState {
    top: string;
    visibility: string;
}

export class Description extends Component<IDescriptionProps, IState> {

    private popover: any;

    constructor() {
        super();

        this.state = {
            top: null,
            visibility: "hidden"
        };

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    protected onMouseEnter() {
        const state: any = {visibility: "visible"};
        if(this.state.top == null) {
            const rect = this.popover.getBoundingClientRect();
            state.top = (-(rect.height / 2) + 7) + "px";
        }
        this.setState(state);
    }

    protected onMouseLeave() {
        this.setState({visibility: "hidden"});
    }

    render() {
        const style = {
            display: "block",
            left: "2px",
            top: this.state.top,
            visibility: this.state.visibility
        };

        return (
            <span>
                <a href="javascript:void(0)" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    <i className="icon-question-sign"/>
                </a>
                <div style={{display: "inline", position: "absolute", width: "100%"}}>
                    <div ref={popover => this.popover = popover} className="popover right" style={style}>
                        <div className="arrow">&nbsp;</div>
                        <div className="popover-content" style={{color: "#333333"}}>{this.tr(this.props.text)}</div>
                    </div>
                </div>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/extensions/Description.tsx